export default __webpack_public_path__ + "53946c0bd0ea1cc3689700e75ea37a84.svg";